import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityApiVolumeTableExportSlice } from './post';

export const coreDataSecurityApiVolumeTableExportReducers = combineReducers({
	post: postCoreDataSecurityApiVolumeTableExportSlice.asyncReducers
});

export const coreDataSecurityApiVolumeTableExportWatchers = combineAllWatchers([
	postCoreDataSecurityApiVolumeTableExportSlice.asyncWatchers
]);
